import {Component, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import { Router } from '@angular/router';
import { CalendarEventAction, CalendarEventTimesChangedEvent, } from 'angular-calendar';
import { isSameDay, isSameMonth } from 'date-fns';
import {Observable, Subject, Subscription, tap} from 'rxjs';
import { AppData } from 'src/app/data-store';
import { UploadPanelComponent } from 'src/app/document-management/components/upload-panel/upload-panel.component';
import {
  ScadenzaModRinvioComponent
} from '../../../common/components/fascicolo/scadenzario-rinvio/scadenza-mod-rinvio.component';
import { Adempimento } from '../../../common/models/adempimento';
import { ScadenzaResponse } from '../../../common/models/dto/scadenza-response';
import { SearchAdempimentiResponse } from '../../../common/models/dto/search-adempimenti-response';
import { ObservableManager } from '../../../common/utils/observable-manager';
import { DocumentManagementService } from "../../../document-management/services/document-management.service";
import { FrontEndMapping } from '../../configuration/front-end-mapping';
import { ServicePathsSettings } from '../../configuration/service-paths-settings';
import { UrlSettingsCore } from '../../configuration/url-settings-core';
import { AttivitaCompletare } from '../../models/attivita-completare';
import { CalendarEventWithPathAttribute } from '../../models/calendar-event-with-path-attribute';
import { FilesList } from '../../models/files';
import { NotificaAttivita } from '../../models/notifica-attivita';
import { HelpersService } from '../../services/helpers.service';
import { ModalNotifyService } from '../../services/modal-notify.service';
import { OperationsService } from '../../services/operations.service';
import { ViewManagerService } from '../../services/view-manager-service';
import { DialogService } from '../dialog/dialog.service';
import { FileManagerService } from '../upload-tool/services/file-manager.service';
import {NomiDescrittoriSezione} from "../../../common/configuration/nomi-descrittori-sezione";
import {CtxBodyAbstract} from "../../../common/models/ctx-body-abstract";
import {DescrittoreSezione} from "../../../common/models/descrittore-sezione";
import {HttpClient} from "@angular/common/http";
import { ModalSyncCalendarComponent } from '../modal-sync-calendar/modal-sync-calendar.component';
import {filter, switchMap, takeUntil} from "rxjs/operators";
import {ConfirmModalComponent} from "../dialog/components/confirm-modal/confirm-modal.component";
import { ScadenzaEvadiComponent } from 'src/app/common/components/fascicolo/scadenza-evadi/scadenza-evadi.component';

declare var $: any;

const colors: any = {
  red: { primary: '#D62A2A', secondary: '#D62A2A' },
  green: { primary: '#71BB1F', secondary: '#71BB1F' },
  yellow: { primary: '#F5AA2E', secondary: '#F5AA2E' },
  transparent: { primary: '', secondary: '' },
};

@Component({
  selector: 'main [welcome-board]',
  templateUrl: 'welcome-board.component.html',
  host: { '[attr.id]': '\'content\'' },
  styleUrls: ['./welcome-board.component.css']
})
export class WelcomeBoardComponent implements OnInit, OnDestroy {

  constructor(
    public observableManager: ObservableManager,
    public viewManager: ViewManagerService,
    protected operationService: OperationsService,
    private router: Router,
    private modalNotifyService: ModalNotifyService,
    private frontEndMapping: FrontEndMapping,
    private fileManager: FileManagerService,
    private helperService: HelpersService,
    private dialog: DialogService,
    private documentManagementService: DocumentManagementService,
    private httpClient: HttpClient
  ) {
   }

  @ViewChild('modalContent') modalContent: TemplateRef<any>;
  @ViewChild('modaleRinvioScadenza')
  modaleRinvioScadenza: ScadenzaModRinvioComponent;
  @ViewChild('modalSyncCalendar') modalSyncCalendar: ModalSyncCalendarComponent;

  subscriptionEvadi: Subscription;
  events: CalendarEventWithPathAttribute[] = [];
  refresh: Subject<any> = new Subject();
  activeDayIsOpen = false;

  adempimentiInevasiList: Adempimento[] = [];
  prossimiAdempimentiList: Adempimento[] = [];
  notifiche: NotificaAttivita[] = [];
  attivitaCompletareList: AttivitaCompletare[] = [];
  viewAllAdempimentiInevasi: string = UrlSettingsCore.URL_ADEMPIMENTI_INEVASI;
  viewAllNotifiche: string = UrlSettingsCore.URL_NOTIFICHE_UTENTE;
  viewAllAttivitaCompletare: string = UrlSettingsCore.URL_ATTIVITA_COMPLETARE;
  viewAllProssimiAdempimenti: string = UrlSettingsCore.URL_PROSSIMI_ADEMPIMENTI;
  numToViewProssimiAdempimenti = 5;
  numToViewAdempimentiInevasi = 5;
  numToViewNotifiche = 5;
  numToViewAttivitaCompletare = 5;
  urlForICalendar: string;

  view = 'month';
  viewDate: Date = new Date();

  modalData: {
    action: string;
    event: CalendarEventWithPathAttribute;
  };

  eventi: any = [
    { id: 'privato', label: 'Privati' },
    { id: 'pubblico', label: 'Pubblici' },
    { id: 'tutti', label: 'Tutti' },
  ];
  eventoSel: any;

  millisDateStart: number;
  millisDateEnd: number;
  uploadedFiles: FilesList[] = []
  dataStore = AppData.getInstance();
  actions: CalendarEventAction[] = [
    {
      label: '<i class="glyphicon glyphicon-ok"></i>',
      onClick: ({
        event,
      }: {
        event: CalendarEventWithPathAttribute;
        sourceEvent: MouseEvent;
      }): void => {
        this.handleEvent('Evadi', event);
      },
    },
    {
      label: '<i class="glyphicon glyphicon-share-alt"></i>',
      onClick: ({
        event,
      }: {
        event: CalendarEventWithPathAttribute;
        sourceEvent: MouseEvent;
      }): void => {
        this.handleEvent('Rinvia', event);
      },
    },
  ];

  firstLoad = false;
  calendarLoaded = false;

  private componentDestroyed$: Subject<void> = new Subject<void>();

  ngOnInit() {
    this.eventoSel = this.eventi[2];
    this.viewManager.svuotaMenu();
    this.viewManager.showHeader();
    this.populateNotifiche(true, true, true, true);
    this.onFilesListUpdate();


  }

  ngOnDestroy() {
    if(this.subscriptionEvadi) this.subscriptionEvadi.unsubscribe();
    this.componentDestroyed$.next();
  }

  private onFilesListUpdate() {
    // console.log("[onFilesListUpdate]", "...");
    this.fileManager.filesList.pipe(takeUntil(this.componentDestroyed$)).subscribe(files => {
      this.uploadedFiles = files;
      // this.uploadedFiles = this.uploadedFiles.sort((a, b) => a.nomeFile.localeCompare(b.nomeFile))
      // console.log("[onFilesListUpdate]", this.uploadedFiles);
      if(files != null && files.length > 0 && !this.dataStore.tipiDocumento && !this.dataStore.tipiProvenienzaDocumento) {
        this.helperService.getTipiDocumenti()
          .subscribe(res => {
            const sortedResponse = this.responseSort(res);
            this.dataStore.tipiDocumento = sortedResponse;
          })
        this.helperService.getTipiProvenienzaDocumento()
          .subscribe(res => {
            const sortedResponse = this.responseSort(res);
            this.dataStore.tipiProvenienzaDocumento = sortedResponse;
          })
      }
      this.scrollToTop();

    });
  }

  private responseSort(res) {
    res.sort((a, b)=>(a.label < b.label ) ? -1 : 1)
    return res
  }

  private scrollToTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
  loadCalendar() {
    if (!this.firstLoad) {
      this.calendarLoaded = true;
      this.firstLoad = true;
      this.viewDateChange(new Date());
    }
  }

  /*populateDocumentToProcess() {
    this.documentManagementService.getDocumentToProcess().subscribe(res => {
      let recDoc = res.fileDataList.map(file =>
        ({
          refDocumentale:file.refDocumentale,
          title: file.nomeFile,
          progress: 100,
          versione: file.versione,
        })
      );
      this.fileManager.updateFilesList(recDoc);
      console.log(this.uploadedFiles)

    });

  }*/

  public openUploadPanelDialog(file: FilesList) {
    // console.log("[openUploadPanelDialog]", file);
    const ref = this.dialog.open(UploadPanelComponent, { data: {
      file,
      style: {
        width: '50%'
      },
      title: 'Caricamento nuovo documento',
      options: {
        tipiDocumento: this.dataStore.tipiDocumento,
        tipiProvenienzaDocumento: this.dataStore.tipiProvenienzaDocumento
      }
    }
    });
    ref.afterClosed.subscribe()
  }

  onDeleteFile(file) {
    // console.log("[onDeleteFile]", file);
    const ref = this.dialog.open(ConfirmModalComponent, {
      data: {
        modalConfirm: {
          text: 'Sei sicuro di voler eliminare il documento' + ' ' + '<b>' + file.nomeFile + '<b>' + '?',
          data: [],
        },
        style: {
          width: '30%',
        },
        title: 'Eliminazione Documento',
      }
    })
    ref.afterClosed.pipe(
      takeUntil(this.componentDestroyed$),
      filter(response => response.modalEvent),
      tap(() => this.deleteSingleFile(file))
    ).subscribe();

  }

  deleteSingleFile(file) {
    // console.log("[deleteSingleFile]", file);
    this.operationService.deleteFile(file.refDocumentale).subscribe(
      (response) =>{
        const updatedList = this.uploadedFiles;
        const index = this.uploadedFiles.findIndex(el => el.refDocumentale === file.refDocumentale);
        if(index > -1) updatedList.splice(index, 1);
        this.fileManager.updateFilesList(updatedList);
      },
      (error) => {}
    );
  }

  onEditFile(event: {newValue: string, oldValue: string}) {
    // console.log("[onEditFile]", event);
    const index = this.uploadedFiles.findIndex(i => i.name === event.oldValue);
    if(index > -1) {
      this.uploadedFiles[index].title = event.newValue;
      this.fileManager.updateFilesList(this.uploadedFiles);
    }
  }

  openCal() {
    this.modalSyncCalendar.inizializza();
  }

  getUrlForICalendar() : Observable<string> {
    return this.operationService.getUrlForICalendar();
  }

  populateNotifiche(
    refreshAdempimenti: boolean,
    refreshNotifiche: boolean,
    refreshAttivitaDaCompletare: boolean,
    isInit: boolean = false
  ) {

    this.notificheService();

  }

  notificheService(){

    this.operationService.getProssimiAdempimenti({ fromResult: this.prossimiAdempimentiList.length, })
    .subscribe((response) => {
      this.prossimiAdempimentiListResult(response);
      this.operationService.getAdempimentiInevasi({ fromResult: this.adempimentiInevasiList.length, })
        .subscribe((response) => {
          this.adempimentiInevasiListResult(response);
          this.operationService.prendiNotificheAttivitaPaginate({ fromResult: 0 })
            .subscribe((response) => {
              this.notifiche = response.notifiche;
              this.viewManager._refreshNotifiche.next({param: response, timeOut: false})
              this.operationService.prendiAttivitaCompletarePaginate({ fromResult: 0 })
                .subscribe((response) => {
                  this.attivitaCompletareList = response.attivita;
                  this.viewManager._refreshAttivitaCompletare.next({param: response, timeOut: false});
                  this.loadCalendar();
                });
            });
        });
    });

  }


  prossimiAdempimentiListResult(response: SearchAdempimentiResponse) {
    this.viewManager._prossimiAdempimenti.next({param: response, timeOut: false})
    if (response.adempimenti.length > 0) {
      let responseAdempimenti: Adempimento[] = response.adempimenti;
      let dataDal = new Date().valueOf(); // today
      let dataAl = new Date((new Date()).getTime() + 7 * 24 * 60 * 60 * 1000).valueOf(); // today + 7
      responseAdempimenti = responseAdempimenti.filter(
        (a: Adempimento) =>
          a.dataScadenza >= dataDal && a.dataScadenza <= dataAl
      );
      this.prossimiAdempimentiList =
        this.prossimiAdempimentiList.concat(responseAdempimenti);
    }
  }

  adempimentiInevasiListResult(response: SearchAdempimentiResponse) {
    this.viewManager._adempimentiInevasi.next({param: response, timeOut: false});
    if (response.adempimenti.length > 0) {
      const responseAdempimenti = response.adempimenti;
      this.adempimentiInevasiList =
        this.adempimentiInevasiList.concat(responseAdempimenti);
    }
  }

  adempimentiCalendarioPresi(response: SearchAdempimentiResponse) {
    if (response.adempimenti.length > 0) {
      for (const adempimento of response.adempimenti) {
        const eventiPerData = response.adempimenti.filter(
          (item) =>
            new Date(item.dataScadenza).getDate() ===
            new Date(adempimento.dataScadenza).getDate()
        );
        this.addEventFromAdempimento(adempimento, eventiPerData);
      }

      this.addButtonMore(500);
    }
    this.calendarLoaded = false;
    // this.recuperaUrlSincCalendario();
  }

  rinvioAdempimento(adempimento) {
    this.apriModaleRinvio(adempimento);
  }

  cambioEvento(evento) {
    console.log('Cambio evento:', evento);
    this.eventoSel = evento;
    this.events = [];
    this.operationService
      .callAdempimentiCalendario(
        ServicePathsSettings.URL_ADEMPIMENTI_CALENDARIO,
        {
          dateTo: this.millisDateEnd,
          dateFrom: this.millisDateStart,
          size: '400',
          visibilita: this.eventoSel.id,
        }
      )
      .subscribe((response) => this.adempimentiCalendarioPresi(response));
  }

  callAdempimentiCalendario(millisDateStart: number, millisDateEnd: number) {
    this.events = [];
    this.millisDateEnd = millisDateEnd;
    this.millisDateStart = millisDateStart;
    // tslint:disable-next-line: max-line-length
    this.operationService
      .callAdempimentiCalendario(
        ServicePathsSettings.URL_ADEMPIMENTI_CALENDARIO,
        {
          dateTo: millisDateEnd,
          dateFrom: millisDateStart,
          size: '400',
          visibilita: this.eventoSel.id,
        }
      )
      .subscribe((response) => this.adempimentiCalendarioPresi(response));
  }

  addEventFromAdempimento(
    adempimento: Adempimento,
    eventiPerData: Adempimento[]
  ) {
    let colorePriorita: any;
    switch (adempimento.priorita.id) {
      case '1':
        colorePriorita = colors.red;
        break;
      case '2':
        colorePriorita = colors.yellow;
        break;
      case '3':
        colorePriorita = colors.green;
        break;
    }

    // ++++ INIZIO ottenimento dati pratica ++++
    let datiPratica = '';

    let posizioneFasc = adempimento.posizione;
    if (posizioneFasc) {
      posizioneFasc = posizioneFasc.trim();
    } else {
      posizioneFasc = '';
    }

    let contropartePrimaria = adempimento.contropartePrimaria;
    if (contropartePrimaria) {
      contropartePrimaria = contropartePrimaria.trim().toUpperCase();
    } else {
      contropartePrimaria = '';
    }
    
    if (posizioneFasc !== '' && contropartePrimaria !== '' ) {
      datiPratica = '[' + posizioneFasc + ' | ' + contropartePrimaria + '] - ';
    } else if (posizioneFasc !== '' || contropartePrimaria !== '') {
      datiPratica = '[' + posizioneFasc + contropartePrimaria + '] - ';
    }
    // ++++ FINE ottenimento dati pratica ++++

    let nota: string =
      datiPratica +
      adempimento.tipoScadenza.label +
      ' - ' +
      adempimento.motivo.label;

    if (adempimento.dataScadenza) {
      const dataScadenza: Date = new Date(adempimento.dataScadenza);
      let oraScadenza: string = '' + dataScadenza.getHours();
      if (oraScadenza.length === 1) {
        oraScadenza = '0' + oraScadenza;
      }
      let minutiScadenza: string = '' + dataScadenza.getMinutes();
      if (minutiScadenza.length === 1) {
        minutiScadenza = '0' + minutiScadenza;
      }

      nota = nota + ' (' + oraScadenza + ':' + minutiScadenza + ')';
    }

    if (adempimento.appunto && adempimento.appunto.trim().length > 0) {
      nota = nota + ' - ' + adempimento.appunto;
    }

    const maxViewForCellMonth = 4; // numero max di icone da visualizzare per cella (tab mese). Bug su IE se piu di 5
    const countEvents = eventiPerData.length;
    const eventIndex = eventiPerData.findIndex(
      (item) => item.id === adempimento.id
    );
    let addClass = '';
    if (
      countEvents >= maxViewForCellMonth &&
      eventIndex >= maxViewForCellMonth
    ) {
      addClass = 'not-view ';
    }

    if (
      countEvents >= maxViewForCellMonth &&
      eventIndex === maxViewForCellMonth
    ) {
      addClass = addClass + 'more-events-btn ';
    }
    const title = nota + (adempimento.pubblica ? ' - PUBBLICO' : ' - PRIVATO');
    this.events.push({
      start: new Date(adempimento.dataScadenza),
      title,
      actions: this.actions,
      draggable: false,
      color: colorePriorita,
      path: this.createPathSezione(adempimento),
      cssClass:
        addClass +
        (adempimento.tipoScadenza && adempimento.tipoScadenza.label
          ? adempimento.tipoScadenza.label.toLowerCase().indexOf('attivit') ===
            0
            ? 'cal-event-attivita'
            : 'cal-event-' + adempimento.tipoScadenza.label.toLowerCase()
          : 'no-tipo-Scadenza'),
      adempimento,
    });
    this.refresh.next(null);
  }

  dayClicked({
    date,
    events,
  }: {
    date: Date;
    events: CalendarEventWithPathAttribute[];
  }): void {
    if (isSameMonth(date, this.viewDate)) {
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
        this.viewDate = date;
        this.addButtonMore(0);
      }
    }
  }

  eventTimesChanged({
    event,
    newStart,
    newEnd,
  }: CalendarEventTimesChangedEvent): void {
    this.callAdempimentiCalendario(newStart.getTime(), newEnd.getTime());
    event.start = newStart;
    event.end = newEnd;
    this.handleEvent(
      'Dropped or resized',
      event as CalendarEventWithPathAttribute
    );
    this.refresh.next(null);
  }

  handleEvent(action: string, event: CalendarEventWithPathAttribute): void {
    if (action === 'Clicked') {
      this.router.navigate([event.path]);
    } else if (action === 'Evadi') {
      this.subscriptionEvadi =
        this.modalNotifyService.notifyConfirmObservable.subscribe(
          (result) => {
          if (!!result) {
            this.openDialogEvadi(result, event.adempimento.id);
          }
          else{
            this.subscriptionEvadi.unsubscribe();
          }
        });
      this.modalNotifyService.notifyEvadiScadenza();
    } else if (action === 'Rinvia') {
      this.apriModaleRinvio(event.adempimento);
    }
  }

  openDialogEvadi(result: boolean, idScadenza: string) {
    this.subscriptionEvadi.unsubscribe();
    const ref = this.dialog.open(ScadenzaEvadiComponent, {
      data: {
        style: {
          width: '50%',
          overflow: false
        },
        idAdempimento: idScadenza,
        title: 'Evadi adempimento',
      }
    });
    ref.afterClosed.subscribe((event) => {
      if(!event || event.closeEvent) return;
      if(event.dataEvasione) {
        let payload = {
          dataEvasione: event.dataEvasione, 
          motivoEvasione: event.motivoEvasione
        };
        this.executeEvasione(result, idScadenza, payload)
      }
    });
  }

  executeEvasione(result: boolean, idScadenza: string, payload) {
    if (result) {
     this.operationService.evadiAdempimentoParams(ServicePathsSettings.URL_EVADI_ADEMPIMENTO, idScadenza, payload).
       subscribe(response => this.resultEvadi(response));
    }
    if (this.subscriptionEvadi) {
      this.subscriptionEvadi.unsubscribe();
    }
  }

  apriModaleRinvio(adempimento: Adempimento) {
    this.modaleRinvioScadenza.inizializza(
      ServicePathsSettings.URL_RINVIO_ADEMPIMENTO,
      adempimento,
      adempimento.idFascicolo,
      true
    );
  }

  resultEvadi(response: ScadenzaResponse) {
    console.log(response, 'res')
    if (response.returnCode === 'OK') {
      const model = this;
      this.viewDateChange(model.viewDate);
      // this.populateNotifiche(true, false, false);
    }
  }

  createPathSezione(adempimento: Adempimento) {
    // let nomePraticaFE = FrontEndMapping.tipiPratica[Number(adempimento.tipoPratica.id)];
    let nomePraticaFE = '';
    this.frontEndMapping
      .getListTipiPratica(adempimento.tipoPratica.id)
      .subscribe((res) => {
        nomePraticaFE = res;
      });
    // let nomeFascicoloFE = FrontEndMapping.tipiFascicolo[Number(adempimento.tipoFascicolo.id)];
    let nomeFascicoloFE = '';
    this.frontEndMapping
      .getListTipiFascicolo(adempimento.tipoFascicolo.id)
      .subscribe((res) => {
        nomeFascicoloFE = res;
      });
    return (
      '/fascicolo/' +
      nomePraticaFE +
      '/' +
      nomeFascicoloFE +
      '/' +
      UrlSettingsCore.URL_VISUALIZZA_SEZIONE_SCADENZARIO +
      '/' +
      adempimento.idFascicolo
    );
    // this.router.navigate(['/fascicolo/'+nomePraticaFE+'/'+nomeFascicoloFE+'/'+UrlSettingsCore.URL_VISUALIZZA_SEZIONE_SCADENZARIO+'/'+adempimento.idFascicolo]);
  }

  viewDateChange(date: Date) {
    this.viewDate = date;
    const newDate = new Date(date);
    // console.log("millis" + newDate.getTime() + ", day = " + newDate.getDay() + ", view = " + this.view);
    let millisecondDateEnd: number;
    let millisecondDateStart: number;
    if (this.view === 'month') {
      const dateStart: Date = newDate;
      dateStart.setDate(1);
      dateStart.setHours(0, 0, 0, 0);
      let yearDataEnd: number = dateStart.getFullYear();
      let monthDateEnd: number = dateStart.getMonth() + 1;
      if (monthDateEnd === 12) {
        monthDateEnd = 0;
        yearDataEnd = yearDataEnd + 1;
      }
      const dateEnd: Date = new Date();
      dateEnd.setFullYear(yearDataEnd);
      dateEnd.setMonth(monthDateEnd);
      dateEnd.setDate(1);
      dateEnd.setHours(0, 0, 0, 0);
      millisecondDateEnd = dateEnd.getTime() - 1000;
      millisecondDateStart = dateStart.getTime();
      // console.log("dateStart = " + dateStart);
      // console.log("dateEnd = " + new Date(millisecondDateEnd));
    } else if (this.view === 'week') {
      const millisecondSunday: number =
        newDate.getTime() - newDate.getDay() * 60000 * 60 * 24;
      const dateStart: Date = new Date(millisecondSunday);
      dateStart.setHours(0, 0, 0, 0);
      millisecondDateStart = dateStart.getTime();
      millisecondDateEnd = millisecondDateStart + 7 * 60000 * 60 * 24 - 1000;
      // console.log("dateStart = " + dateStart);
      // console.log("dateEnd = " + new Date(millisecondDateEnd));
    } else if (this.view === 'day') {
      const dateStart: Date = newDate;
      dateStart.setHours(0, 0, 0, 0);
      millisecondDateStart = dateStart.getTime();
      millisecondDateEnd = millisecondDateStart + 60000 * 60 * 24 - 1000;
      // console.log("dateStart = " + dateStart);
      // console.log("dateEnd = " + new Date(millisecondDateEnd));
    }
    this.callAdempimentiCalendario(millisecondDateStart, millisecondDateEnd);
    this.manageHeaderCalendario();
  }

  changedView(newView: string) {
    this.view = newView;
    this.viewDateChange(this.viewDate);
    this.manageHeaderCalendario();
  }

  refreshCalendar(azioneCompiuta: string) {
    const model = this;
    this.viewDateChange(model.viewDate);
    if (azioneCompiuta && azioneCompiuta === 'rinvio') {
      this.prossimiAdempimentiList = [];
      this.adempimentiInevasiList = [];
      this.notificheService();
    }
  }

  manageHeaderCalendario() {
    if (this.view === 'week') {
      $('.ngcalendar h2').first().css('visibility', 'hidden');
      setTimeout(function () {
        $('body, body *')
          .contents()
          .filter(function () {
            return (
              this.nodeType === Node.TEXT_NODE &&
              this.nodeValue.indexOf('Week') >= 0
            );
          })
          .each(function () {
            this.nodeValue = this.nodeValue
              .replace(/\bWeek \b/g, 'Settimana ')
              .replace(/\b of \b/g, ' dell\'anno ');
            $('.ngcalendar h2').first().css('visibility', 'visible');
          });
      }, 500);
    }
  }

  addButtonMore(millisec) {
    if (this.view === 'month') {
      setTimeout(function () {
        $('.more-events-btn').before('<p class="view-more-events">...</p>');
      }, millisec);
    }
  }

  formattaData(data: string){
    if(this.view === 'day'){
      const subStrings = data.split(',');
      const newDayString = subStrings[1].split(' ')[2] + ' ' + subStrings[1].split(' ')[1];
      return subStrings[0] + ', ' + newDayString + ',' + subStrings[2];
    } else {
      return data;
    }
  }

  getDocumentManagementDescriptor(descriptors: DescrittoreSezione[]): DescrittoreSezione {
    return descriptors.find(a => a.entitySimpleName == NomiDescrittoriSezione.DESCRITTORE_GESTIONE_DOCUMENTI);
  }
}
